// extracted by mini-css-extract-plugin
export default {"container":"base-timeline-content-module__container--nH3IQ","hasTransition":"base-timeline-content-module__hasTransition--I9VGn"};